var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-link--transit",attrs:{"href":_vm.href}},[(_vm.$slots.default)?[_c('label',[_vm._t("default")],2)]:[_c('label',[_vm._v("More")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }